import { Menu } from './menu';
import { IdentityUser } from './user';

/**
 * Obtiene el menú del usuario
 * @param {IdentityUser} user usuario
 * @returns {Menu[]} menú del usuario
 */
const getMenu = (user: IdentityUser): Menu[] => {
  try {
    // Validar que el usuario y su menú existan
    if (!user?.menu) {
      return [];
    }

    // Intentar parsear el JSON del menú
    const parsedMenu = JSON.parse(user.menu) as unknown;

    // Validar que el menú parseado sea un array
    if (!Array.isArray(parsedMenu)) {
      return [];
    }

    // Validar que cada elemento del menú tenga la estructura esperada
    const validMenu = parsedMenu.filter(
      (menu: unknown) =>
        menu &&
        typeof menu === 'object' &&
        menu !== null &&
        'name' in menu &&
        'menuItems' in menu &&
        typeof (menu as { name: unknown }).name === 'string' &&
        Array.isArray((menu as { menuItems: unknown }).menuItems)
    );

    return validMenu as Menu[];
  } catch (error) {
    console.error('Error al parsear el menú del usuario:', error);
    return [];
  }
};

/**
 * Operaciones de identidad
 */
export const IdentityOperations = {
  getMenu
};
